// Site content for Isaiah Artavia
export const SITE = {
  name: "Isaiah Artavia",
  title: "Actor & Performer",
  tagline: "A stage. A spotlight. A story worth telling.",
  intro:
    "Lead performer from Moose Jaw, Saskatchewan — trained singer, dancer and actor known for charged stage presence, remarkable storytelling, and the kind of charm that fills a house.",
  bio: [
    "Isaiah Artavia is a Saskatchewan-based actor and performer whose work spans musical theatre, stage drama, and screen. From Tarzan and Sky Masterson to real-life characters like Moses, he is sure to bring an impressive performance — drawn to roles that ask for honesty, range, and a sense of play, and to stories that earn their stillness as much as their spectacle.",
    "His approach is grounded in classical discipline and a real love for the craft: a present stage voice, instinctive improvisation, and a calm presence under direction. He is open to opportunities across theatre, film, television, and commercial work.",
  ],
  contact: {
    phone: "306-631-5943",
    phoneHref: "tel:+13066315943",
    email: "artisaiah352@gmail.com",
    emailHref: "mailto:artisaiah352@gmail.com",
    location: "Moose Jaw, Saskatchewan",
    address: "655 Coteau Street West, Moose Jaw, SK, S6H 5E5",
  },
  representation: {
    status: "Currently Seeking Representation",
    note: "Open to inquiries from agents, managers, casting directors, and production teams. For direct booking and representation inquiries, please use the form below.",
  },
  reel: {
    youtubeId: "5uehfnFjsaw",
    youtubeUrl: "https://www.youtube.com/watch?v=5uehfnFjsaw",
    title: "Performance Reel",
    subtitle: "A selection of recent work — Tarzan, The Little Mermaid, Guys & Dolls, and more.",
  },
  resumePdf:
    "https://customer-assets.emergentagent.com/job_performer-showcase-4/artifacts/2tv2jt7l_Acting%20Resume%20-%20Updated.pdf",
  social: [
    { label: "Instagram", handle: "@isaiah_artavia", href: "https://www.instagram.com/isaiah_artavia/", icon: "instagram" },
    { label: "Instagram", handle: "@isaiahartavia", href: "https://www.instagram.com/isaiahartavia/", icon: "instagram" },
    { label: "TikTok", handle: "@isaiah.artavia", href: "https://www.tiktok.com/@isaiah.artavia", icon: "tiktok" },
    { label: "Facebook", handle: "isaiah.artavia", href: "https://www.facebook.com/isaiah.artavia/", icon: "facebook" },
    { label: "Spotify", handle: "Listen on Spotify", href: "https://open.spotify.com/artist/3DzBjaXE2NlC58IDAYXmrQ?si=8dSD4pcLQIaPSBgJj0RS5A", icon: "spotify" },
    { label: "YouTube", handle: "Performance Reel", href: "https://www.youtube.com/watch?v=5uehfnFjsaw", icon: "youtube" },
  ],
  stats: [
    { value: "Lead", label: "Musical Theatre" },
    { value: "Stage", label: "Trained" },
    { value: "On Camera", label: "Available" },
  ],
};

export const HERO_IMAGE =
  "https://customer-assets.emergentagent.com/job_performer-showcase-4/artifacts/t0bb1uvw_6T1A8406-DxO_DeepPRIME%203.jpg";

// Use the staircase shot for About
export const ABOUT_IMAGE =
  "https://customer-assets.emergentagent.com/job_performer-showcase-4/artifacts/6v63rnt0_6T1A7775.jpg";

export const GALLERY = [
  {
    src: "https://customer-assets.emergentagent.com/job_performer-showcase-4/artifacts/t0bb1uvw_6T1A8406-DxO_DeepPRIME%203.jpg",
    alt: "Spotlight, empty theater",
    caption: "Under the spotlight",
    span: "wide",
    category: "Portrait",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_performer-showcase-4/artifacts/9mj6fp77_Photo%202026-05-22%2C%207%2032%2014%20PM.jpg",
    alt: "Moses, The Prince of Egypt",
    caption: "Moses — The Prince of Egypt",
    span: "tall",
    category: "Performance",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_performer-showcase-4/artifacts/f68s71m9_Photo%202024-11-05%2C%209%2008%2024%20PM.jpg",
    alt: "Eric, The Little Mermaid",
    caption: "Eric — The Little Mermaid",
    span: "regular",
    category: "Performance",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_performer-showcase-4/artifacts/gle4fdjy_Screenshot%202026-06-18%20at%2011.11.00%E2%80%AFAM.png",
    alt: "Headshot",
    caption: "Headshot",
    span: "regular",
    category: "Portrait",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_performer-showcase-4/artifacts/6ut07q5l_6T1A7922.jpg",
    alt: "Full body, brick wall",
    caption: "Brick & bowtie",
    span: "regular",
    category: "Portrait",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_performer-showcase-4/artifacts/cw1b889v_6T1A7732.jpg",
    alt: "Headshot, arms crossed",
    caption: "Studio portrait",
    span: "regular",
    category: "Portrait",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_performer-showcase-4/artifacts/x2ympdc2_EE0093A9-0CFC-458E-8E92-E8B4075DCCBC.PNG",
    alt: "Studio headshot, dark background",
    caption: "Smile, dark studio",
    span: "regular",
    category: "Portrait",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_performer-showcase-4/artifacts/t4rgbl0y_IMG_9642.JPG",
    alt: "Studio headshot, side light",
    caption: "Side light",
    span: "regular",
    category: "Portrait",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_performer-showcase-4/artifacts/9lataae1_IMG_9730.JPG",
    alt: "Studio headshot, low key",
    caption: "Low key",
    span: "regular",
    category: "Portrait",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_performer-showcase-4/artifacts/6v63rnt0_6T1A7775.jpg",
    alt: "Staircase, gold railing",
    caption: "The descent",
    span: "tall",
    category: "Portrait",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_performer-showcase-4/artifacts/mk5ujbun_6T1A7750.jpg",
    alt: "Seated, park bench",
    caption: "In repose",
    span: "wide",
    category: "Portrait",
  },
];

// Full credits — taken verbatim from the most recent resume
export const CREDITS = {
  theatre: [
    { year: "2026", role: "Moses (Lead)", project: "The Prince of Egypt", venue: "Born to Be Arts Academy · Mae Wilson Theatre" },
    { year: "2025", role: "Co-writer / Asst. Director", project: "Voltage: Covenant", venue: "Joe's Place Youth Center · Hillcrest" },
    { year: "2025", role: "Tarzan (Lead)", project: "Tarzan: The Broadway Musical", venue: "Cornerstone Christian School · Mae Wilson" },
    { year: "2025", role: "Featured Act", project: "Inspire 2025", venue: "passion2action · Conexus Arts Centre, Regina" },
    { year: "2025", role: "Sky Masterson (Lead)", project: "Guys & Dolls", venue: "Born to Be Arts Academy" },
    { year: "2024", role: "Eric (Lead)", project: "The Little Mermaid", venue: "Cornerstone Christian School · Mae Wilson" },
    { year: "2024", role: "Davey (Featured)", project: "Newsies", venue: "Born to Be Arts Academy" },
    { year: "2023", role: "Tal (Lead)", project: "Voltage: Destiny", venue: "Joe's Place Youth Center · Hillcrest" },
    { year: "2023", role: "Singer (Ensemble)", project: "A Not So Silent Christmas", venue: "Born to Be Arts · Church of God" },
    { year: "2023", role: "Troy (Lead)", project: "High School Musical", venue: "Cornerstone Christian School · Mae Wilson" },
    { year: "2023", role: "Dmitry (Lead)", project: "Anastasia", venue: "Born to Be Arts Academy · Mae Wilson / Regina Little Theatre" },
    { year: "2023", role: "Tom (Featured)", project: "Radium Girls", venue: "Cornerstone Christian · One-Act Provincials (Runner-up) · U of R" },
    { year: "2022", role: "Alien (Extra)", project: "Voltage: Gravitate", venue: "Joe's Place Youth Center · Hillcrest" },
    { year: "2022", role: "Timmy / Elsa / Wise Men / Ensemble", project: "The Little Town of Christmas", venue: "Born to Be Arts · Church of God" },
    { year: "2022", role: "Cogsworth (Featured)", project: "Beauty and the Beast", venue: "Cornerstone Christian School · Mae Wilson" },
    { year: "2022", role: "Lionel the Royal Steward (Featured)", project: "Cinderella: The Enchanted Edition", venue: "Born to Be Arts · Mae Wilson" },
    { year: "2022", role: "Runaway (Featured)", project: "One Stoplight Town", venue: "Cornerstone Christian · Peacock / U of R" },
    { year: "2021", role: "Horton the Elephant (Lead)", project: "Seussical", venue: "Cornerstone Christian · Mae Wilson" },
    { year: "2019", role: "Lt. Ward / Politician (Supporting)", project: "Annie", venue: "Cornerstone Christian · Mae Wilson" },
  ],
  film: [
    { year: "2022", role: "Isaac (Featured)", project: "Fear and Trembling", venue: "Black Light Studios · filmed at Mae Wilson, Moose Jaw" },
    { year: "2022", role: "Background (Extra)", project: "The Pull", venue: "Sons in the Sky · Moose Jaw" },
  ],
  training: [
    { year: "2022 – Present", role: "Voice", project: "Private Voice Lessons", venue: "Josh Carley" },
    { year: "2022 – Present", role: "Dance", project: "Ballet · Jazz · Musical Theatre · Tap", venue: "Born to Dance" },
  ],
  work: [
    { year: "2022 – 2024", role: "Actor / Retail Clerk", project: "Tunnels of Moose Jaw", venue: "Live-action interpretive performance" },
  ],
  awards: [
    { year: "Jul 2025", title: "Canada West Musical Theatre — 1st Place", detail: "Ages 17 and under" },
    { year: "Apr 2023", title: "Best Overall Actor", detail: "Moose Jaw Regional One-Acts · Tom in Radium Girls" },
    { year: "2018 – 2026", title: "Best Actor", detail: "Annie · Seussical · One Stoplight Town · High School Musical · The Little Mermaid · Tarzan" },
  ],
  skills: [
    "Trained singer (voice — Josh Carley)",
    "Strong stage voice & projection",
    "Talented actor — takes direction",
    "Ability to improvise",
    "Strong memorization skills",
    "Dance experience (ballet, jazz, musical theatre, tap)",
    "Excels in public speaking",
    "Crowd-pleasing & charming",
    "Stays composed under pressure",
    "Positive attitude, theoretically minded",
  ],
};
